import axios from "axios";

const API_BASE = process.env.REACT_APP_BACKEND_URL;

// Reads the per-tab impersonation/demo session (set by the Test Lab launcher).
export const getImpersonation = () => {
  try {
    const email = sessionStorage.getItem("impersonation_email") || "";
    const isDemo = sessionStorage.getItem("impersonation_mode") === "demo";
    return { active: !!email, email, isDemo };
  } catch {
    return { active: false, email: "", isDemo: false };
  }
};

// Ends the impersonation/demo session and returns the admin to the demo launcher.
export const exitImpersonation = () => {
  try {
    const mode = sessionStorage.getItem("impersonation_mode");
    const token = sessionStorage.getItem("impersonation_token");
    if (mode === "session" && token) {
      axios.post(`${API_BASE}/api/sales/test-lab/impersonate/exit`, { token }).catch(() => {});
    }
    localStorage.removeItem("diag_session");
    sessionStorage.removeItem("impersonation_token");
    sessionStorage.removeItem("impersonation_email");
    sessionStorage.removeItem("impersonation_mode");
    sessionStorage.removeItem("impersonation_env");
  } catch { /* ignore */ }
  if (window.opener) window.close();
  else window.location.replace("/app/demo");
};
